import { MapPin, Ruler, Check, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { PROPERTY_CATEGORIES, SITE } from "@/data/content";

export default function Properties() {
  const waFor = (cat) =>
    `${SITE.whatsapp}?text=${encodeURIComponent(
      `Hello Sunil ji, I want details for ${cat.name} in Dholera. Please share current availability and pricing.`
    )}`;

  return (
    <section id="properties" className="py-24 lg:py-32 bg-paper" data-testid="properties-section">
      <div className="container-luxe">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-6">
          <Reveal className="lg:col-span-8">
            <p className="eyebrow mb-4">Property Opportunities</p>
            <h2 className="font-serif font-semibold text-navy text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Dholera Property &amp; Plot Opportunities
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-4">
            <p className="text-body leading-relaxed">
              Residential, commercial, industrial and investment land — enquire for currently available options.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-navy/50 border-l-2 border-gold pl-4 leading-relaxed mb-12">
            The cards below are sample presentations. Actual inventory, locations and pricing are shared on enquiry — availability in Dholera changes frequently.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-8" data-testid="property-cards-grid">
          {PROPERTY_CATEGORIES.map((cat, i) => (
            <Reveal key={cat.id} delay={0.08 * i} y={40} className="group bg-white border border-border shadow-card rounded-sm overflow-hidden hover:shadow-gold-glow transition-shadow duration-300">
              <div className="relative h-56 overflow-hidden">
                <img src={cat.image} alt={cat.alt} loading="lazy" className="w-full h-full object-cover img-treatment transition-transform duration-700 group-hover:scale-105" />
                <span className="absolute top-4 left-4 bg-navy/85 backdrop-blur text-white font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">
                  {cat.name}
                </span>
                <span className="absolute top-4 right-4 bg-gold text-navy font-mono text-[10px] uppercase tracking-[0.14em] px-3 py-1.5 font-semibold">
                  Sample Listing
                </span>
              </div>
              <div className="p-7">
                <h3 className="font-serif text-2xl text-navy font-semibold">{cat.listing}</h3>
                <p className="mt-2 flex items-center gap-2 text-body text-sm">
                  <MapPin className="w-4 h-4 text-gold-dark shrink-0" /> {cat.location}
                </p>
                <div className="mt-4 flex flex-wrap gap-x-8 gap-y-2 text-sm text-navy font-medium">
                  <span className="flex items-center gap-2"><Ruler className="w-4 h-4 text-gold-dark" /> {cat.sizes}</span>
                  <span className="font-mono text-gold-dark font-semibold" data-testid={`property-price-${cat.id}`}>{cat.price}</span>
                </div>
                <ul className="mt-5 space-y-2">
                  {cat.highlights.map((h) => (
                    <li key={h} className="flex items-start gap-2.5 text-sm text-body">
                      <Check className="w-4 h-4 text-gold-dark mt-0.5 shrink-0" /> {h}
                    </li>
                  ))}
                </ul>
                <div className="mt-6 pt-5 border-t border-border flex flex-wrap items-center justify-between gap-4">
                  <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-[#128C4B] flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#25D366] inline-block" /> {cat.status}
                  </span>
                  <a href={waFor(cat)} target="_blank" rel="noopener noreferrer" data-testid={`property-get-details-${cat.id}`} className="inline-flex items-center gap-2 text-sm font-semibold text-navy border-b-2 border-gold pb-1 hover:text-gold-dark transition-colors duration-300">
                    Get Details <ArrowRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-12 text-center">
          <p className="text-body text-sm">
            Looking for something specific?{" "}
            <a href={SITE.whatsapp} target="_blank" rel="noopener noreferrer" className="font-semibold text-navy border-b border-gold hover:text-gold-dark transition-colors duration-300">
              WhatsApp us your requirement
            </a>{" "}
            — we will share matching options with current pricing.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
